export const GLOBAL_PARAMS_SAVED = "Charisma.Leasing.PublishedLanguage.Events.GlobalParams.GlobalParamsSaved";
